import * as Yup from 'yup';

export default Yup.object().shape({
  barCode: Yup.string().required(),
});
